import { getApiUrl, AXIOS_AUTHED, DEFAULT_PAGEABLE } from './shared';
import { serializeAsQueryString } from '../../utils/utils';
import { constructPageString } from '../../utils/api-util';

const BRANCH_PRODUCTS_BASE_URL = `${getApiUrl()}/branch-products`;

const DEFAULT_SEARCH = {
  productCodes: null,
  branchIds: null
};

const search = (pageable = DEFAULT_PAGEABLE, criteria = DEFAULT_SEARCH) => {
  const pageString = constructPageString(pageable);
  const queryString = buildQueryString(criteria);
  return AXIOS_AUTHED.get(
    `${BRANCH_PRODUCTS_BASE_URL}?${pageString}&${queryString}`
  );
};

const count = (criteria) => {
  return AXIOS_AUTHED.get(
    `${BRANCH_PRODUCTS_BASE_URL}/count?${buildQueryString(criteria)}`
  );
};

function buildQueryString(criteria) {
  return serializeAsQueryString(
    {
      ...criteria,
      search: undefined, // delete this one
      productCodes: [criteria.search]
    },
    true
  );
}

export { search, count };
